var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _c("div", { staticClass: "table" }, [
          _c("table", [
            _c("thead", [
              _c("tr", [
                _c("th", [_vm._v("Profissional")]),
                _vm._v(" "),
                _c("th", [_vm._v("Data e duração")]),
                _vm._v(" "),
                _c("th", [_vm._v("Ação")])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.orders, function(order) {
                return _c("tr", { key: order.id }, [
                  _c("td", [
                    _c("div", { staticClass: "with-image" }, [
                      _c("img", {
                        attrs: {
                          src:
                            order.professional.account.profile.profile_picture
                        }
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(order.professional.account.first_name) +
                          " " +
                          _vm._s(order.professional.account.last_name) +
                          "\n              "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatDate")(
                          order.schedule_event.starts_at,
                          "DD/MM [às] H[h]"
                        )
                      ) +
                        " - " +
                        _vm._s(
                          _vm._f("secToHours")(
                            order.schedule_event.duration,
                            true
                          )
                        )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "buttons", attrs: { nowrap: "" } },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "btn btn-small bg-purple-outline float-right",
                          attrs: { to: "pedidos/" + order.id }
                        },
                        [_vm._v("ir para o pedido")]
                      )
                    ],
                    1
                  )
                ])
              })
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row align-center" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Pedidos")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-813af42a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-813af42a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cycle/Orders/Desktop.vue
// module id = null
// module chunks = 